<template>
  <!-- Start Cloud Hosting Services -->
  <section class="services-area ptb-80 bg-f7fafd">
    <div class="container">
      <div class="row h-100 justify-content-center align-items-center">
        <div class="col-lg-6 col-md-12 services-content">
          <div class="section-title">
            <h2>{{ t('atonline_drive_title') }}</h2>
            <div class="bar"></div>
            <p>{{ t('atonline_drive_p') }}</p>
          </div>

          <div class="row">
            <div class="col-lg-6 col-md-6">
              <div class="box">
                <i data-feather="shield"></i> {{ t('atonline_drive_feature_1') }}
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <div class="box">
                <i data-feather="wind"></i> {{ t('atonline_drive_feature_2') }}
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <div class="box">
                <i data-feather="cloud"></i> {{ t('atonline_drive_feature_3') }}
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <div class="box">
                <i data-feather="clock"></i> {{ t('atonline_drive_feature_4') }}
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <div class="box">
                <i data-feather="folder"></i> {{ t('atonline_drive_feature_5') }}
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <div class="box">
                <i data-feather="sun"></i> {{ t('atonline_drive_feature_6') }}
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <div class="box">
                <i data-feather="dollar-sign"></i> {{ t('atonline_drive_feature_7') }}
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <div class="box">
                <i data-feather="smile"></i> {{ t('atonline_drive_feature_8') }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-12 services-right-image">
          <img src="/img/services-right-image/book-self.png" class="wow fadeInDown" data-wow-delay="0.6s" alt="book-self">
          <img src="/img/services-right-image/box.png" class="wow fadeInUp" data-wow-delay="0.6s" alt="box">
          <img src="/img/services-right-image/chair.png" class="wow fadeInLeft" data-wow-delay="0.6s" alt="chair">
          <img src="/img/services-right-image/cloud.png" class="wow zoomIn" data-wow-delay="0.6s" alt="cloud">
          <img src="/img/services-right-image/cup.png" class="wow bounceIn" data-wow-delay="0.6s" alt="cup">
          <img src="/img/services-right-image/flower-top.png" class="wow fadeInDown" data-wow-delay="0.6s" alt="flower">
          <img src="/img/services-right-image/head-phone.png" class="wow zoomIn" data-wow-delay="0.6s" alt="head-phone">
          <img src="/img/services-right-image/monitor.png" class="wow fadeInUp" data-wow-delay="0.6s" alt="monitor">
          <img src="/img/services-right-image/mug.png" class="wow rotateIn" data-wow-delay="0.6s" alt="mug">
          <img src="/img/services-right-image/table.png" class="wow fadeInUp" data-wow-delay="0.6s" alt="table">
          <img src="/img/services-right-image/tissue.png" class="wow zoomIn" data-wow-delay="0.6s" alt="tissue">
          <img src="/img/services-right-image/water-bottle.png" class="wow zoomIn" data-wow-delay="0.6s" alt="water-bottle">
          <img src="/img/services-right-image/wifi.png" class="wow fadeInLeft" data-wow-delay="0.6s" alt="wifi">
          <img src="/img/services-right-image/cercle-shape.png" class="bg-image rotateme" alt="shape">
          
          <img src="/img/services-right-image/main-pic.png" class="wow fadeInUp" data-wow-delay="0.6s" alt="main-pic">
        </div>
      </div>
    </div>
  </section>
  <!-- End Cloud Hosting Services -->
</template>

<script>
import { onMounted } from 'vue'
import feather from 'feather-icons'
import i18next from '../i18next.js'

export default {
  name: 'CloudHostingServices',
  setup() {
    // Simple translation function
    const t = (key) => i18next.t(key);
    
    onMounted(() => {
      // Reinitialize Feather Icons
      feather.replace()
    })
    
    return { t }
  }
}
</script>

<style scoped>
/* Services styling is handled in the imported CSS */
</style>